import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
export default class UtilsListInfo extends Component{
  constructor(props){
    super(props);
  }
  render(){
    return(
      <div className="mobile-asset-list">

      <div className="asset-listing-wrap utilization-history" style={{marginLeft:'0px'}} >
        <div className="asset-list-filter-sort">
          <Row className="filter-block">
            <Col><h6>Month</h6></Col>
            <Col><h6>Major Assembly</h6></Col>
            <Col><h6>Hours</h6></Col>
            <Col><h6>Cycles</h6></Col>
            <Col><h6>TSN ( Hrs )</h6></Col>
            <Col><h6>CSN ( Cycles )</h6></Col>
          </Row>
        </div>
        {this.props.children}
      </div>
      </div>
    )
  }
}
